import { Injectable } from "@angular/core";
import { Plugins } from "@capacitor/core";
import { TranslateService } from "@ngx-translate/core";
import { MarketModel } from "src/app/models/market.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { DateService } from "../date/date.service";

const { Device } = Plugins;
const { Share } = Plugins;
declare var FB: any;

@Injectable({
  providedIn: "root"
})
export class ShareService {
  public producerHome = "/producer/";
  public consumerHome = "/consumer/";
  public authorityHome = "/authority/";
  public adminHome = "/admin/";

  constructor(private dateService: DateService, private translateService: TranslateService) {}

  async shareTourneeFB(tournee: TourneeModel): Promise<void> {
    const info = await Device.getInfo();
    const url = this.getTourneeURL(tournee);
    if (info.platform == "ios" || info.platform == "android") {
      const message =
        this.translateService.instant("tournee.IllBe") +
        " " +
        this.translateService.instant("common.in") +
        " " +
        tournee.details.geocoding.address.city +
        " " +
        this.translateService.instant("common.dateArticle") +
        " " +
        this.dateService.formatToLongDate(tournee.details.date) +
        ". " +
        this.translateService.instant("tournee.YouCanOrder") +
        ".";
      await Share.share({
        title: this.translateService.instant("tournee.OrderFromMySale"),
        text: message,
        url: url,
        dialogTitle: this.translateService.instant("tournee.ShareSaleFB")
      });
    } else {
      FB.ui(
        {
          method: "share",
          href: url
        },
        function (response) {}
      );
      //const url = `https://www.facebook.com/dialog/share?app_id=${facebookConfig.appId}&display=popup&href=${this.getTourneeURL(tournee)}&redirect_uri=${this.getTourneeURL(tournee)}`
      // await Browser.open({url:url});
    }
  }

  async shareProfileFB(profile: ProfileModel): Promise<void> {
    const info = await Device.getInfo();
    const url = this.getProfileURL(profile);
    if (info.platform == "ios" || info.platform == "android") {
      const message =
        this.translateService.instant("producer.share.FBMessage")
      await Share.share({
        title: this.translateService.instant("producer.share.FBTitle"),
        text: message,
        url: url,
        dialogTitle: this.translateService.instant("producer.share.FBDialogTitle")
      });
    } else {
      FB.ui(
        {
          method: "share",
          href: url
        },
        function (response) {}
      );
      //const url = `https://www.facebook.com/dialog/share?app_id=${facebookConfig.appId}&display=popup&href=${this.getTourneeURL(tournee)}&redirect_uri=${this.getTourneeURL(tournee)}`
      // await Browser.open({url:url});
    }
  }

  getTourneeURL(tournee: TourneeModel): string {
    if (tournee.details?.format == 'group') {
      if (tournee.details?.link) {
        return `https://app.latourneedesproducteurs.com/${tournee.details.link}`;
      } else {
        return `https://app.latourneedesproducteurs.com/market/${tournee.key}`;
      }
    }
    else if ("market" in tournee) {
      if (tournee.market.details?.link) {
        return `https://app.latourneedesproducteurs.com/${tournee.market.details.link}`;
      } else {
        return `https://app.latourneedesproducteurs.com/market/${tournee.market.key}`;
      }
    } else {
      if (tournee.details?.link) {
        return `https://app.latourneedesproducteurs.com/${tournee.producer.details.link}/${tournee.details.link}`;
      } else {
        //      return `https://app.latourneedesproducteurs.com/sale/${tournee.details.geocoding.address.countryCode}/${tournee.details.geocoding.address.postalCode}/${tournee.status}/${tournee.key}`
        return `https://app.latourneedesproducteurs.com/sale/${tournee.key}`;
      }
    }
  }

  getProfileURL(profile: ProfileModel): string {
    return `https://app.latourneedesproducteurs.com/${profile.details.link}`;
  }
  getTourneeImage(tournee: TourneeModel): string {
    return `https://app.latourneedesproducteurs.com/assets/photos/${tournee.details.type}.jpg`;
  }

  getMarketURL(market: MarketModel): string {
    if (market.details.link) {
      return `https://app.latourneedesproducteurs.com/${market.details.link}`;
    } else {
      return `https://app.latourneedesproducteurs.com/market/${market.key}`;
    }
  }

  getSaleURL(sale: TourneeModel | MarketModel): string {
    return sale.details.format ==='group'? this.getMarketURL(sale as MarketModel): this.getTourneeURL(sale);
  }

  async shareMarketFB(market: MarketModel) {
    const info = await Device.getInfo();
    const url = this.getMarketURL(market);
    if (info.platform == "ios" || info.platform == "android") {
      const message = `${market.details.name} se tiendra à  ${market.details.geocoding.address.city} le ${this.dateService.formatToLongDate(
        market.details.date
      )}. Vous pouvez passer commande auprès des producteurs participants sur La Tournée des Producteurs.`;
      await Share.share({
        title: this.translateService.instant("market.OrderFromProducers"),
        text: message,
        url: url,
        dialogTitle: this.translateService.instant("market.ShareMarketFB")
      });
    } else {
      FB.ui(
        {
          method: "share",
          href: url
        },
        function (response) {}
      );
      //const url = `https://www.facebook.com/dialog/share?app_id=${facebookConfig.appId}&display=popup&href=${this.getTourneeURL(tournee)}&redirect_uri=${this.getTourneeURL(tournee)}`
      // await Browser.open({url:url});
    }
  }

  sendEmail(to:string,subject:string,body:string){
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
  }

  formatEmailLTDP (hidden: string, title: string, subtitle: string, photoURL: string, content: string, buttonURL: string, buttonText: string, footerSubtitle: string, footerContent: string): string {
    const email = `
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=1">
            <body style='padding:25px; margin:0px; background-color:#F9F6F0'>
                <div style="mso-hide:all; visibility:hidden; opacity:0; color:transparent; mso-line-height-rule:exactly; line-height:0; font-size:0px; overflow:hidden; border-width:0; display:none !important;">
                    ` + hidden + `
                </div>
                <div style='max-width: 600px; width: 100%; margin:auto;'>
                    <div style="height:88px;text-align: center;background: url('https://app.latourneedesproducteurs.com/assets/icon/logo-small.png') no-repeat center center /contain">
                    </div>
                    <div style="padding:20px; margin-top:20px; background: url('` + photoURL + `') no-repeat center center / cover; height: 100px;">
                        <h2 style="color:#ee940d; background-color:rgba(236, 235, 231,0.8);    font-size: 20px; font-family: Arial, Helvetica, sans-serif;
                            margin-bottom:2px;margin-top:2px;padding:2px 10px;text-align: center;border-radius:5px;font-weight: bolder;width: fit-content;">
                            ` + title + `
                        </h2>
                        <h2 style="color:#003c3a; background-color:rgba(236, 235, 231,0.8);    font-size: 18px; font-family: Arial, Helvetica, sans-serif;
                            margin-bottom:2px;margin-top:2px;padding:2px 10px;text-align: center;border-radius:5px;font-weight: bolder;width: fit-content;">
                            ` + subtitle + `
                        </h2>
                    </div>
                    <div style="padding:20px; font-size: 16px; color: #585757; background-color:white; font-family: Arial, Helvetica, sans-serif;">
                        ` + content + `
                        <div style="text-align: center; margin-top:20px">
                            <a href="` + buttonURL + `" style="display:inline-block; text-decoration: none; padding: 12px; background-color: #ee940d;color:white; font-size:20px; font-weight:bold; border-radius: 5px; border: 2px solid white;">` + buttonText + `</a>
                        </div>
                    </div>
                    <div style="padding:20px; font-size: 16px; color: white; background-color:#003c3a; font-family: Arial, Helvetica, sans-serif;">
                        <h2>` + footerSubtitle + `</h2>
                        ` + footerContent + `
                    </div>
                </div>
            </body>`;
    return email;
  };
  formatProducerEmail (hidden: string, title: string, subtitle: string, photoURL: string, 
                content: string, buttonURL: string, buttonText: string, footerSubtitle: string, footerContent: string): string {
    const email = `
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1,minimum-scale=1, maximum-scale=1">
            <body style='padding:25px; margin:0px; background-color:white'>
                <div style="mso-hide:all; visibility:hidden; opacity:0; color:transparent; mso-line-height-rule:exactly; line-height:0; font-size:0px; overflow:hidden; border-width:0; display:none !important;">
                    ` + hidden + `
                </div>
                <div style='max-width: 600px; width: 100%; margin:auto;'>
                    <div style="padding:20px; margin-top:20px; background: url('` + photoURL + `') no-repeat center center / cover; height: 100px;">
                        <h2 style="color:#ee940d; background-color:rgba(236, 235, 231,0.8);    font-size: 20px; font-family: Arial, Helvetica, sans-serif;
                            margin-bottom:2px;margin-top:2px;padding:2px 10px;text-align: center;border-radius:5px;font-weight: bolder;width: fit-content;">
                            ` + title + `
                        </h2>
                        <h2 style="color:#003c3a; background-color:rgba(236, 235, 231,0.8);    font-size: 18px; font-family: Arial, Helvetica, sans-serif;
                            margin-bottom:2px;margin-top:2px;padding:2px 10px;text-align: center;border-radius:5px;font-weight: bolder;width: fit-content;">
                            ` + subtitle + `
                        </h2>
                    </div>
                    <div style="padding:20px; font-size: 16px; color: #585757; background-color:white; font-family: Arial, Helvetica, sans-serif;">
                        ` + content + `
                        <div style="text-align: center; margin-top:20px">
                            <a href="` + buttonURL + `" style="display:inline-block; text-decoration: none; padding: 12px; background-color: #13316e;color:white; font-size:20px; font-weight:bold; border-radius: 5px; border: 2px solid white;">` + buttonText + `</a>
                        </div>
                    </div>
                    <div style="padding:20px; font-size: 16px; color: #585757; background-color:white; font-family: Arial, Helvetica, sans-serif;">
                        <h2>` + footerSubtitle + `</h2>
                        ` + footerContent + `
                    </div>
                </div>
            </body>`;
    return email;
  };
}
